const login: { [key: string]: any } = {
    "Auth.form.error.username.taken": "Nome de usuário já cadastrado",
    "Auth.form.error.email.taken": "E-mail já cadastrado",
};

export default login;
